import { showHide } from './utils/showHide'
const toggles = document.getElementsByClassName('toggle-children')
const jumpMenu = document.getElementById('jump-menu')

if (jumpMenu !== null) {
  jumpMenu.addEventListener('change', function () {
    location.replace(this.value)
  })
}

if (toggles !== null && toggles.length > 0) {
  for (const toggle of toggles) {
    toggle.addEventListener('click', function () {
      this.classList.toggle('activated')
      showHide(this.parentNode.getElementsByTagName('ul')[0])
    })
  }
}
